import { InternationalizationProvider } from '@astryxdesign/core/i18n';
import { LinkProvider } from '@astryxdesign/core/Link';
import { Theme } from '@astryxdesign/core/theme';
import ru from '@astryxdesign/core/locales/ru-RU.json';
import { useMemo, type ReactNode } from 'react';
import { RouterLink } from './RouterLink';
import { createStudioTheme } from './theme';

const messages = { 'ru-RU': ru };

/** Theme + locale + router links. The accent is the studio's, from the DB. */
export function AppProviders({ accent, children }: { accent: string; children: ReactNode }) {
  const theme = useMemo(() => createStudioTheme(accent), [accent]);
  return (
    <Theme theme={theme} mode="dark">
      <InternationalizationProvider locale="ru-RU" messages={messages}>
        <LinkProvider component={RouterLink}>{children}</LinkProvider>
      </InternationalizationProvider>
    </Theme>
  );
}
